// loader-interceptor.service.ts
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService, SessionSecurityService } from '@shared/services';
import { Observable } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  urlCheck = false;
  constructor(private loaderService: LoaderService, private sessionSecurity: SessionSecurityService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }
 
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const noSpinner = this.sessionSecurity.getObject('UserApproved');
   
     // this.requests.push(req);
     if (!req.url.toLowerCase().includes('notificationiconcount')) {
      this.requests.push(req);
      this.loaderService.isLoading.next(true);
    }

     // if (!noSpinner) {
          //this.loaderService.isLoading.next(true);
    //  }
    
      return new Observable(observer => {
        const subscription = next.handle(req)
          .subscribe(
            event => {
              if (event instanceof HttpResponse) {
                this.removeRequest(req);
                observer.next(event);
              }
            },
            err => {
              console.log('error' + err);
              this.removeRequest(req);
              observer.error(err);
            },
            () => {
              this.removeRequest(req);
              observer.complete();
            });
        // remove request from queue when cancelled
        return () => {
          this.removeRequest(req);
          subscription.unsubscribe();
        };
      });
    }
}
